.reactionsDialogList {
  margin: 0;
  margin-bottom: 1rem;
}

.reactionsDialogListItem {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
}

.reactionsDialogListClickable:hover, .reactionsDialogListClickable:focus {
  background-color: var(--chatListItemBgHover);
}

.reactionsDialogAvatar {
  flex: 0 0 48px;
  margin-inline: 10px;
}

.reactionsDialogContactName {
  flex: 1;
  margin-inline-end: 10px;
  overflow: hidden;
}

.reactionsDialogEmoji {
  flex: 0 0 50px;
  font-size: 20px;
  text-align: center;
}